import React, {useEffect} from 'react';
import {StyleSheet, View, TextInput, Image} from 'react-native';
import colors from 'theme/Colors';
import {corner_radius, spacing} from 'theme/Units';
import {Icon, Text} from 'ui-kits';
import {Suggestion} from './Suggestion';
import {dashboardSearchSuggestions} from 'redux/selectors/dashboardSelector';
import {smartSearchRequest} from 'redux/slices/dashboardSlice';
import {useDebounceState} from 'hooks';
import {FlatList} from 'react-native-web';
import {useDispatch, useSelector} from 'react-redux';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';

type propType = Readonly<{
  navigation: NativeStackScreenProps<RootNavigatorParams>['navigation'];
}>;
const debounceDelay = 200;

export function SmartSearch({navigation}: propType) {
  const [searchText, setSearchText] = useDebounceState<string>(
    '',
    debounceDelay,
  );
  const suggetions = useSelector(dashboardSearchSuggestions);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(smartSearchRequest({search_text: searchText ?? ''}));
  }, [searchText, dispatch]);

  const suggestionContent = suggetions.length > 0 ? (
    <FlatList
      data={suggetions}
      renderItem={({item}) => (
        <Suggestion
          {...item}
          key={item.id}
          navigation={navigation}
          searchText={searchText ?? ''}
        />
      )}
      keyExtractor={item => item?.id?.toString()}
      style={styles.suggetionContainer}
    />
  ) : (
    <View style={styles.suggetionContainer}>
      <Text style={styles.fallbackText}>
        No results found! But we’re always improving—soon, you'll be able
        to search both internally and externally. Stay tuned for smarter
        search!{' '}
      </Text>
    </View>
  )

  return (
    <View style={styles.container}>
      <View style={styles.inputContainer}>
        <Image
          resizeMode="contain"
          source={require('assets/images/AI-search.png')}
          style={styles.aiIcon}
        />
        <TextInput
          style={styles.input}
          onChangeText={text => setSearchText(text)}
          placeholder="Need something? Just search!"
          placeholderTextColor={colors.palette.nuetral4Placeholder}
        />
        <Icon type="search" size={16} />
      </View>
      {searchText ? (
        suggestionContent
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  fallbackText: {
    fontWeight: 500,
    color: colors.palette.brandDarkGray,
    fontSize: 16,
    margin: spacing['3']
  },
  suggetionContainer: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: colors.palette.white,
    paddingHorizontal: spacing['1'],
    paddingVertical: spacing['2'],
    borderColor: colors.palette.neutralN300,
    borderRadius: corner_radius['rounded-lg'],
    marginTop: spacing['1'],
    borderWidth: 1,
  },
  inputContainer: {
    backgroundColor: colors.palette.white,
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: colors.palette.neutralN300,
    borderRadius: corner_radius['rounded-lg'],
    alignItems: 'center',
    paddingHorizontal: spacing['2'],
  },
  suggetions: {},
  input: {
    flex: 1,
    padding: spacing['1'],
    fontSize: 16,
    fontWeight: 500,
  },
  aiIcon: {width: 40, height: 40},
});
